module.exports = __webpack_public_path__ + "img/side-sleeper-black.ac8c60a.svg";